export default __webpack_public_path__ + "static/tik-tak-b7669ebc79df97b2c132a7f6602639c0.mp3";